import { styled } from '@linaria/react';
import { Group, Stack } from '@mantine/core';
import type { ReactNode } from 'react';
import { primaryBase, primaryLightest } from '../../../../styles/design-tokens';
import { Text } from '../../../../ui-library/typography/typography';

interface TooltipMetadataRow {
  label?: string;
  value: ReactNode;
  color?: string;
}

interface InitiativeTooltipContentProps {
  initiativeKey?: string | null;
  initiativeName: string;
  progress?: number;
  metadataRows?: TooltipMetadataRow[];
}

export function InitiativeTooltipContent({
  initiativeKey,
  initiativeName,
  progress,
  metadataRows = [],
}: InitiativeTooltipContentProps) {
  return (
    <Stack gap={2}>
      <Group justify="space-between">
        <Text weight="bold">{initiativeKey}</Text>
        {progress !== undefined && <CompletionPercentage>{Math.round(progress)}%</CompletionPercentage>}
      </Group>
      <Text weight="bold">{initiativeName}</Text>
      {metadataRows.map((row, index) => (
        <Group key={index} justify="space-between">
          <Text>{row.label}</Text>
          <Text color={row.color}>{row.value}</Text>
        </Group>
      ))}
    </Stack>
  );
}

const CompletionPercentage = styled.div`
  font-size: 10px;
  font-weight: 600;
  color: ${primaryBase};
  background: ${primaryLightest};
  text-align: right;
  flex-shrink: 0;
  padding: 2px 6px;
  border-radius: 4px;
`;
